import {
  ICityBirthdatePayload,
  IDeleteAccountPayload,
  IOptinPayload,
  IPasswordPayload,
  ISetPicturePrivacyPayload,
} from '../api/models/account/account.types';
import { ActionsUnion, createAction } from '../helpers';
import { IMember } from '../members/types';
import { IPicturesEntries } from '../pictures/types';
import { IAccount, IOptins } from './types';

export enum EAccountActionType {
  GET = 'ACCOUNT/GET',
  GET_SUCCESS = 'ACCOUNT/GET_SUCCESS',
  PATCH_ANNOUNCE = 'ACCOUNT/ANNOUNCE/PATCH',
  PATCH_ANNOUNCE_SUCCESS = 'ACCOUNT/ANNOUNCE/PATCH_SUCCESS',
  GET_PROFILE = 'ACCOUNT/PROFILE/GET',
  GET_PROFILE_SUCCESS = 'ACCOUNT/PROFILE/GET_SUCCESS',
  GET_PICTURES = 'ACCOUNT/PICTURES/GET',
  GET_PICTURES_SUCCESS = 'ACCOUNT/PICTURES/GET_SUCCESS',
  GET_OPTINS = 'ACCOUNT/OPTINS/GET',
  GET_OPTINS_SUCCESS = 'ACCOUNT/OPTINS/GET_SUCCESS',
  PATCH_OPTIN = 'ACCOUNT/OPTINS/PATCH',
  PATCH_OPTIN_SUCCESS = 'ACCOUNT/OPTINS/PATCH_SUCCESS',
  PATCH_OPTIN_ERROR = 'ACCOUNT/OPTINS/PATCH_ERROR',
  PATCH_CITY_BIRTHDATE = 'ACCOUNT/CITY_BIRTHDATE/PATCH',
  PATCH_CITY_BIRTHDATE_SUCCESS = 'ACCOUNT/CITY_BIRTHDATE/PATCH_SUCCESS',
  PATCH_COMPLETED_PROFILE = 'ACCOUNT/COMPLETED_PROFILE/PATCH',
  PATCH_COMPLETED_PROFILE_SUCCESS = 'ACCOUNT/COMPLETED_PROFILE/PATCH_SUCCESS',
  CHANGE_PASSWORD = 'ACCOUNT/PASSWORD/CHANGE',
  SET_PICTURE_PRIVACY = 'ACCOUNT/PICTURE/SET_PRIVACY',
  SET_PICTURE_PRIVACY_SUCCESS = 'ACCOUNT/PICTURE/SET_PRIVACY/SUCCESS',
  DELETE_ACCOUNT = 'ACCOUNT/DELETE',
}

export const AccountActions = {
  getAccount: () => createAction(EAccountActionType.GET),
  getAccountSuccess: (account: IAccount) =>
    createAction(EAccountActionType.GET_SUCCESS, account),
  patchAnnounce: (announce: string) =>
    createAction(EAccountActionType.PATCH_ANNOUNCE, announce),
  patchAnnounceSuccess: (announce: string) =>
    createAction(EAccountActionType.PATCH_ANNOUNCE_SUCCESS, announce),
  getMyProfile: () => createAction(EAccountActionType.GET_PROFILE),
  getMyProfileSuccess: (myProfile: IMember) =>
    createAction(EAccountActionType.GET_PROFILE_SUCCESS, myProfile),
  getPicturesAccount: () => createAction(EAccountActionType.GET_PICTURES),
  getPicturesAccountSuccess: (pictures: IPicturesEntries) =>
    createAction(EAccountActionType.GET_PICTURES_SUCCESS, pictures),
  getOptins: () => createAction(EAccountActionType.GET_OPTINS),
  getOptinsSuccess: (optins: IOptins) =>
    createAction(EAccountActionType.GET_OPTINS_SUCCESS, optins),
  patchOptin: (newPayload: IOptinPayload, initialPayload: IOptinPayload) =>
    createAction(EAccountActionType.PATCH_OPTIN, {
      newPayload,
      initialPayload,
    }),
  patchOptinSuccess: (payload: IOptinPayload) =>
    createAction(EAccountActionType.PATCH_OPTIN_SUCCESS, payload),
  patchOptinError: (payload: IOptinPayload) =>
    createAction(EAccountActionType.PATCH_OPTIN_ERROR, payload),
  patchCityBirthdate: (payload: ICityBirthdatePayload) =>
    createAction(EAccountActionType.PATCH_CITY_BIRTHDATE, payload),
  patchCityBirthdateSuccess: (payload: ICityBirthdatePayload) =>
    createAction(EAccountActionType.PATCH_CITY_BIRTHDATE_SUCCESS, payload),
  patchHasCompleteProfile: () =>
    createAction(EAccountActionType.PATCH_COMPLETED_PROFILE),
  patchHasCompleteProfileSuccess: () =>
    createAction(EAccountActionType.PATCH_COMPLETED_PROFILE_SUCCESS),
  changePassword: (payload: IPasswordPayload) =>
    createAction(EAccountActionType.CHANGE_PASSWORD, payload),
  setPicturePrivacy: (payload: ISetPicturePrivacyPayload) =>
    createAction(EAccountActionType.SET_PICTURE_PRIVACY, payload),
  setPicturePrivacySuccess: (payload: ISetPicturePrivacyPayload) =>
    createAction(EAccountActionType.SET_PICTURE_PRIVACY_SUCCESS, payload),
  deleteAccount: (payload: IDeleteAccountPayload) =>
    createAction(EAccountActionType.DELETE_ACCOUNT, payload),
};

export type TAccountActions = ActionsUnion<typeof AccountActions>;
